import type { FaireProductEntity } from "../../entity_types/product";

export const p_pryvasyvgu: FaireProductEntity = {
  token: "p_pryvasyvgu",
  type: "product",
  name: "DE LAS FLORES",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.faire.com/fastly/358fac90caebb75080895f1db8bfe778b3506216f1c591a06b5ccb5b4854d9bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b272ef87c18fa54ffdf668b3d52dec2d00aa26976a84b241a1c6541f10268b6e.jpeg",
    "https://cdn.faire.com/fastly/bef456f982a45ba56a79f061ed22654be070a4aa191e7af315a7e0a1325593d8.jpeg",
    "https://cdn.faire.com/fastly/514959aaa796e319ba4df9d1a816222523221bdac760b9550b3898d042d2c5ec.jpeg",
  ],
  priceDollars: 19,
  description:
    "Explore Mexico City's most expansive and vibrant flower market. Meander the endless stalls of local flowers and breathe in the heavenly bouquet around you. Transform your home into a floral haven with soft notes of white lily, gardenia and sweet yucca flower.\n\nyucca flower, lily of the valley, gardenia, wild orris, pink peppercorn\n\nIllustrations by fellow dreamer Freddy Terriquez; when he's not packing candles he's sketching some of our favorite designs.\n\nThese beautiful hand-painted jars are designed to be re-loved and reused.\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n8 ounces (226g), comes in our signature Mexico City box.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:57.275Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
